import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useChangeActiveGroupPresenter } from './ChangeActiveGroupHandler.presenter';

export const ChangeActiveGroupHandler: FC = observer(() => {
  useChangeActiveGroupPresenter();

  return null;
});
